import React from 'react';
import { icons } from './definitions';

export const SiteIcon = ({ negative, height = 24, width = 24 }) => {
  const stroke = negative ? 'white' : '#003B71';
  const path_fill = negative ? 'white' : '#FFBF60';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 128 128"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 8.56237C36.9521 5.69773 42.3237 3.47757 48 2.01658V125.984C42.3237 124.523 36.9521 122.303 32 119.438V8.56237ZM16 21.6671C6.04219 32.9492 0 47.7692 0 64.0003C0 80.2314 6.04219 95.0514 16 106.333V21.6671Z"
        fill={stroke}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 1.23697e-05 64 0L64 128Z"
        fill={path_fill}
      />
    </svg>
  );
};

export const Icon = ({
  className = '',
  color = '',
  name = '',
  width = 24,
  height = 24,
  onClick = () => {},
  active,
  fill
}) => {
  const icon = icons[name] || icons.add;
  const iconStyle = {
    color,
    cursor: onClick ? 'pointer' : 'default',
    fill: active ? '#2B99FF' : fill || 'none'
  };

  return (
    <span onClick={onClick} className={className} style={iconStyle}>
      {icon(width, height)}
    </span>
  );
};
